import api from '../client';

export const TasksService = {
  getTasks: (params) => api.get('/tasks', { params }),
  getPendingValidations: () => api.get('/tasks/pending-validations'),
  getValidationsHistory: () => api.get('/tasks/validations-history'),
  getTaskById: (id) => api.get(`/tasks/${id}`),
  createTask: (data) => api.post('/tasks', data),
  updateTask: (id, data) => api.patch(`/tasks/${id}`, data),
  patchTask: (id, data) => api.patch(`/tasks/${id}`, data),
  deleteTask: (id) => api.delete(`/tasks/${id}`),
  addParticipants: (id, data) => api.post(`/tasks/${id}/participants`, data),
  addDependencies: (id, data) => api.post(`/tasks/${id}/dependencies`, data),
  addComment: (id, data) => api.post(`/tasks/${id}/comments`, data),
  addCommentWithFile: (id, formData) => api.post(`/tasks/${id}/comments`, formData),
  getMyGantt: () => api.get('/tasks/my/gantt'),
  getProjectGantt: (projectId) => api.get(`/tasks/projects/${projectId}/gantt`),
  getPendingChecklists: () => api.get('/tasks/checklists/pending'),
  getChecklistsHistory: () => api.get('/tasks/checklists/history'),
  addChecklistItem: (id, data) => api.post(`/tasks/${id}/checklists`, data),
  updateChecklistItem: (id, itemId, data) => api.patch(`/tasks/${id}/checklists/${itemId}`, data),
  deleteChecklistItem: (id, itemId) => api.delete(`/tasks/${id}/checklists/${itemId}`),
};
